var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "CheckCircle_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#CheckCircle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#16A34A",
  d: "M7.067 9.2 5.634 7.767a.63.63 0 0 0-.467-.184.63.63 0 0 0-.466.184.63.63 0 0 0-.184.466q0 .285.184.467l1.9 1.9a.64.64 0 0 0 .466.2.64.64 0 0 0 .467-.2l3.767-3.766a.63.63 0 0 0 .183-.467.63.63 0 0 0-.183-.467.63.63 0 0 0-.467-.183.63.63 0 0 0-.467.183zm.934 5.467a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425A6.7 6.7 0 0 1 1.859 10.6 6.5 6.5 0 0 1 1.334 8q0-1.383.525-2.6a6.7 6.7 0 0 1 1.425-2.117q.9-.9 2.117-1.424A6.5 6.5 0 0 1 8 1.333q1.383 0 2.6.526 1.216.525 2.116 1.425T14.142 5.4t.525 2.6-.525 2.6a6.7 6.7 0 0 1-1.425 2.117q-.9.9-2.116 1.425a6.5 6.5 0 0 1-2.6.525m0-1.333q2.233 0 3.783-1.55T13.334 8t-1.55-3.783-3.783-1.55-3.784 1.55T2.667 8t1.55 3.784 3.784 1.55"
}))));
export default SvgCheckCircle;